import { Injectable, inject } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { ShipmentRate } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { identity, uniq } from 'lodash-es'
import { Observable, of } from 'rxjs'
import { filter, switchMap, take } from 'rxjs/operators'
import { loadCurrencies, selectCurrency } from 'src/app/store/currencies'
import { ModalService } from 'src/shared/modal/modal.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { CopyFreightRatesFormComponent, CopyFreightRatesFormOptions } from './copy-freight-rates-form.component'

@Injectable()
export class CopyFreightRatesFormService {
  private readonly modal = inject(ModalService)
  private readonly store = inject(Store)
  private readonly toaster = inject(ToasterService)


  showBatchChange(rates: DeepReadonly<ShipmentRate[]>): Observable<ShipmentRate[]> {
    if (!rates.every(({rate}) => rate.currency && (rate.amount || rate.amount === 0))) {
      this.toaster.warning('Please select only rates with both "currency" and "amount" fields set.')
      return of(undefined)
    }
    const currencyCodes = uniq(rates.map(r => r.rate.currency))
    if (currencyCodes.length > 1) {
      this.toaster.warning('Please select rates with the same currency.')
      return of(undefined)
    }
    this.store.dispatch(loadCurrencies({}))
    const rateIds = rates.map(r => r.rate_id)
    return this.store.pipe(select(selectCurrency(currencyCodes[0])), filter(identity), take(1), switchMap(currency =>
      this.modal.openDialog<
        CopyFreightRatesFormComponent,
        CopyFreightRatesFormOptions,
        ShipmentRate[]
      >(
        CopyFreightRatesFormComponent,
        { currency, rateIds },
        { width: '300px' },
      )))
  }
}
